// Zero-scope prefill deep-links for the brief's outbound actions (webapp-actions issue 5, "Full prefill
// pack"). These open the user's OWN Google Calendar / mail client with the fields prefilled — the user
// confirms and sends. Never a silent write, never a new OAuth scope (D-ACT28: compose-scarce; the pack is
// deep-links, not model calls). encodeURIComponent throughout so a space becomes %20 (mailto clients
// treat a `+` as literal, so URLSearchParams' form-encoding is wrong here).

const CALENDAR_RENDER = 'https://calendar.google.com/calendar/render';

/** A Google Calendar "new event" screen prefilled with a title + details. The user picks the time and
 *  invitees in Google's UI, then saves — this does not create anything on its own. */
export function calendarEventUrl(title: string, details: string): string {
  return `${CALENDAR_RENDER}?action=TEMPLATE&text=${encodeURIComponent(title)}&details=${encodeURIComponent(details)}`;
}

/** A mailto: draft prefilled with a subject + body (no recipient — the user picks who). */
export function followUpMailto(subject: string, body: string): string {
  return `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
